import React from 'react';

export default function SpinnerGrowLoading({ isLoading, children }) {
    return isLoading ? (
        <div className="spinner-grow spinner-grow-sm ml-auto" role="status">
            <span className="sr-only">Loading...</span>
        </div>
    ) : (
        children
    );
}
